module.exports = {
  addMobilePushNotification: 'addMobilePushNotification',
  getMobilePushNotification: 'getMobilePushNotification',
  listMobilePushNotification: 'listMobilePushNotification',
  updateMobilePushNotification: 'updateMobilePushNotification',
};